/**
 * O cliente de consultas (TanStack Query) do SPA.
 *
 * Ele mora aqui, e nao em `main.tsx`, porque tres lugares precisam do **mesmo** cliente com
 * os **mesmos** defaults: o ponto de entrada, o contexto do roteador (a guarda de rota le a
 * sessao pelo cache, sem refazer a chamada) e os testes, que montam um cliente novo por caso
 * para nao vazar cache de um teste para o outro.
 */

import { QueryClient } from '@tanstack/react-query'

/**
 * Um cliente novo, com os defaults do CRM.
 *
 * `staleTime` de 30 segundos: a sessao e as listas do CRM nao mudam a cada foco de janela, e
 * sem ele cada troca de aba renderia uma rajada de refetch. `refetchOnWindowFocus: false`
 * pelo mesmo motivo.
 *
 * E uma **fabrica**, e nao um singleton exportado: um cliente de modulo compartilhado entre
 * os testes carregaria o cache de um caso para o seguinte, e o segundo passaria por causa do
 * primeiro.
 */
export function criarClienteDeConsultas(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
    },
  })
}
